import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[action]"
})
export class ShowActionDirective {
  state: string;
  action: string;
  @Input("action") roleName: string;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    var menu = JSON.parse(localStorage.getItem("menu"));
    var StateActionList = this.findProp(menu, "state", "");
    this.getStateAndAction(this.roleName.toLowerCase());
    StateActionList.forEach(element => {
      if (element.state.toLowerCase() == this.state.toLowerCase()) {
        element.actions.forEach(element => {
          if (element.toLowerCase() == this.action.toLowerCase()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          }
        });
      }
    });
  }

  findProp(obj, key, out) {
    var i,
      proto = Object.prototype,
      ts = proto.toString,
      hasOwn = proto.hasOwnProperty.bind(obj);

    if ("[object Array]" !== ts.call(out)) out = [];

    for (i in obj) {
      if (hasOwn(i)) {
        if (i === key) {
          out.push({ state: obj[i], actions: obj["ActionList"].split(",") });
        } else if (
          "[object Array]" === ts.call(obj[i]) ||
          "[object Object]" === ts.call(obj[i])
        ) {
          this.findProp(obj[i], key, out);
        }
      }
    }
    return out;
  }

  getStateAndAction(arr: string) {
    var sep = arr.split(",");
    this.state = sep[0];
    this.action = sep[1];
  }
}
